import { defaultInitialState } from '../utils';
import { GET_SAFETY_SETTINGS, GET_SAFETY_SETTINGS_DONE, GET_SAFETY_SETTINGS_ERR, SET_SAFETY_SETTINGS, SET_SAFETY_SETTINGS_DONE, SET_SAFETY_SETTINGS_ERR, RESET_SAFETY_SETTINGS } from './actionTypes';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { isUpdated: false });
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SAFETY_SETTINGS:
        case SET_SAFETY_SETTINGS:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case GET_SAFETY_SETTINGS_DONE:
            return Object.assign(Object.assign({}, state), { data: action.data, isLoading: false, error: false, errorMessage: null });
        case SET_SAFETY_SETTINGS_DONE:
            return Object.assign(Object.assign({}, state), { data: action.data, isUpdated: true, isLoading: false, error: false, errorMessage: null });
        case GET_SAFETY_SETTINGS_ERR:
        case SET_SAFETY_SETTINGS_ERR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case RESET_SAFETY_SETTINGS:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map